
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexVTt6EMPEBzbD7GYTH8Ge0bxe72jiJQpz9zTMRx0Ioc4Meta } from "/workspace/app/pages/index.vue?macro=true";
import { default as loginnH9Sl924SFFqGThbV00_J_yNmCDLuvcG8JcX3TTI_1IMeta } from "/workspace/app/pages/login.vue?macro=true";
import { default as pago_45exitosoh_o_5KvompHboC1ItRTXYlUZiDxgO_6KPFQQLWutvq0Meta } from "/workspace/app/pages/pagos/[transactionId]/pago-exitoso.vue?macro=true";
import { default as procesar_45pago0Vnhm5o6RHuJtg_JSsHy_rWCzJUHkKTV7nQRm_ByRH4Meta } from "/workspace/app/pages/pagos/[transactionId]/procesar-pago.vue?macro=true";
import { default as pago_45pendiente26nOTvxA867zmoYm4ktjrEl_PID6qEz7BuJ0Flmyic4Meta } from "/workspace/app/pages/pagos/[transactionId]/pago-pendiente.vue?macro=true";
import { default as pago_45paypalfReWbAiVDukgyViBL5Gs_0TKoB__dEonO90T30ZL96EMeta } from "/workspace/app/pages/pagos/[transactionPaymentId]/pago-paypal.vue?macro=true";
import { default as pago_45oxxo_45payiSe6jqKcORz7U_Ar2lVk7LThrDhQ97hsbXDhi9eqx9EMeta } from "/workspace/app/pages/pagos/[transactionPaymentId]/pago-oxxo-pay.vue?macro=true";
import { default as pago_45apple_45pay7OypDC4UrBmgnTNRkQdy5AQOfw2kGMHJDbcyqZAxcGIMeta } from "/workspace/app/pages/pagos/[transactionPaymentId]/pago-apple-pay.vue?macro=true";
import { default as pago_45google_45payK6m4qISXmGAYZiO10l4cNMo_16tBfLdUstmNZm5n_kMMeta } from "/workspace/app/pages/pagos/[transactionPaymentId]/pago-google-pay.vue?macro=true";
import { default as pago_45mercadopago_45payftrtGoQceZLigzdNBj8TvdLtJnZ0hTXT_IKclGJ8KOwMeta } from "/workspace/app/pages/pagos/[transactionPaymentId]/pago-mercadopago-pay.vue?macro=true";
import { default as pagosjp7ac77yFXd8XnTFBG6GPtyIOQ7iS6yMDB0O5yX_FFAMeta } from "/workspace/app/pages/pagos.vue?macro=true";
import { default as revisarLqnc_SyhqNR57KvnGcHSaAE8bS8mAOq05_gQXVijILcMeta } from "/workspace/app/pages/compra/[[transactionId]]/revisar.vue?macro=true";
import { default as elegir_45pagoKUACAkhvRFFsm4_3C_RT0FP6tv05TlEIIkOyLGC_MaAMeta } from "/workspace/app/pages/compra/[[transactionId]]/elegir-pago.vue?macro=true";
import { default as elegir_45envio_V6miBf6FJBEH83cBU7Hk8LdiBfUvDTc2L3Tkab_9yEMeta } from "/workspace/app/pages/compra/[[transactionId]]/elegir-envio.vue?macro=true";
import { default as detalleqZo46Sv1UJw4t51DBkVJH_GDoobdmAMU8Dn__A_2GLMMeta } from "/workspace/app/pages/compra/[[transactionId]]/carrito/detalle.vue?macro=true";
import { default as elegir_45mensualidad_SSut8WRwlIyL0d7X9dy03P_1lnlRrZRXEboKbgyfH4Meta } from "/workspace/app/pages/compra/[[transactionId]]/elegir-mensualidad.vue?macro=true";
import { default as compraLS2HZ5dTMGZuOX1Da_Eqrc_JcmTN8oj_uyEFNcDDlOsMeta } from "/workspace/app/pages/compra.vue?macro=true";
import { default as marcas6oxowEXAaIpoB7mgH97ptiqkZWaFvUmygC_cjXh863kMeta } from "/workspace/app/pages/marcas.vue?macro=true";
import { default as monederopgbQf1PZ3pXIBitRurUC9D208fWxCOocoBJ1N6VjEGsMeta } from "/workspace/app/pages/perfil/monedero.vue?macro=true";
import { default as favoritosvf8k5EMEI7JaqnXPQcl69Ru4QdajgVwFd3_NXyOyuKIMeta } from "/workspace/app/pages/perfil/favoritos.vue?macro=true";
import { default as informacionXK_FWqihFTWKOq58Jx6_wzWfAv56pEFOd6bxdtatJXEMeta } from "/workspace/app/pages/perfil/informacion.vue?macro=true";
import { default as dispositivosAG5KwUHTBCRduqGu_JFwEh7RqkDCFTzDrnks8W97MfQMeta } from "/workspace/app/pages/perfil/dispositivos.vue?macro=true";
import { default as indexcdU_te6owM400122_R0xGItO0am8ENF60KpqmR7cl_YMeta } from "/workspace/app/pages/perfil/pedidos/index.vue?macro=true";
import { default as _91_91id_93_93SNbFa_8LGibeF82kT8kV6GUIb3xFdO5gknR35WOn3a4Meta } from "/workspace/app/pages/perfil/garantias/[[id]].vue?macro=true";
import { default as crearT9Oj6scR7MAoweFlPFYDw7bDEoCedYZYs4APE3Kh7d8Meta } from "/workspace/app/pages/perfil/direcciones/crear.vue?macro=true";
import { default as indexYTeXohkDrLaOdrYnEywnK158FT1eyheGC_V_TLa5QzgMeta } from "/workspace/app/pages/perfil/direcciones/index.vue?macro=true";
import { default as chatBREu5as8U78h7R5LMjlEPZb8ZhoMTxUaGeZtnWHtLm4Meta } from "/workspace/app/pages/perfil/pedidos/[id]/chat.vue?macro=true";
import { default as indextzgDIbcVlQEaS9r2M_oA3Z9zvkTXo_8d9UCFhRrHjcEMeta } from "/workspace/app/pages/perfil/pedidos/[id]/index.vue?macro=true";
import { default as indexkg4MU_esWW1K2sqVX829KIJvZh9NNe21_EfoiUZUELEMeta } from "/workspace/app/pages/perfil/confirmaciones/index.vue?macro=true";
import { default as tarjetaOV_IhhT0BMk4MHe3iZo_BqTM_pBI_BBotU6vhKzj3pYMeta } from "/workspace/app/pages/perfil/metodos-pago/tarjeta.vue?macro=true";
import { default as editarLDhECKbUmAxS9aqljw24yZxqwYik82Pt23s3lbYTjW0Meta } from "/workspace/app/pages/perfil/direcciones/[id]/editar.vue?macro=true";
import { default as confirmacionNFGkVf0zR8F5FoEtIDy7Vz0m_7bSj3zLx1OMmhITweoMeta } from "/workspace/app/pages/perfil/pedidos/[id]/confirmacion.vue?macro=true";
import { default as indexnR0JPESGJuPQXL_1Cd4Ynq_Dq1GdDEvDS2ieZI8a__AMeta } from "/workspace/app/pages/perfil/pedidos/[id]/garantia/index.vue?macro=true";
import { default as productosON3CsovqpTvUGnGjCuXGv7zKH2Hp4kPyqOs9DfXpvsUMeta } from "/workspace/app/pages/perfil/pedidos/[id]/garantia/productos.vue?macro=true";
import { default as perfil8Sy_UKg_9vVNZ0tdGxONizNO7SW_VX7oekU5WW_urJoMeta } from "/workspace/app/pages/perfil.vue?macro=true";
import { default as sucursalesf0oVbVAWPPBy1zy6eNXtUlbOEW84Dv0h6tY13MYurUgMeta } from "/workspace/app/pages/soporte/sucursales.vue?macro=true";
import { default as contactanoszd_75_UlkS9HafqDGHZMlwKb5MkMbYkYD9aUH6_u8zMMeta } from "/workspace/app/pages/soporte/contactanos.vue?macro=true";
import { default as facturacionTp6Cgw_weDKVhiu4jzW_EHyVJaHE_gCKES5PRkXDIi8Meta } from "/workspace/app/pages/soporte/facturacion.vue?macro=true";
import { default as formas_45de_45pagocG2QzTqrIelcouyVRkIjs7m3Q8g5Fzh7W3HaRJJHtCEMeta } from "/workspace/app/pages/soporte/formas-de-pago.vue?macro=true";
import { default as preguntas_45frecuentesQM_3x4iBoYfIhJy92RCJnDLK9sD48MZO65lJFlERJR4Meta } from "/workspace/app/pages/soporte/preguntas-frecuentes.vue?macro=true";
import { default as soportehUdof3Rq_6QJI7N_mSQUbqi5_KPLmsMCC2bL1tk7k_gMeta } from "/workspace/app/pages/soporte.vue?macro=true";
import { default as privacidadAlR91PW3AuXipEGxylf19wgftYvcbihExelcd8nPTAkMeta } from "/workspace/app/pages/nosotros/privacidad.vue?macro=true";
import { default as aviso_45legalxUM2OmKYMOTsVMVXJOJ1CFNqOx_rKrguWS_rhhn8NQQMeta } from "/workspace/app/pages/nosotros/aviso-legal.vue?macro=true";
import { default as terminos_45y_45condicionesMUiat_Fdl7xz5ZMO7NddQwCe3z_aw3agVbSqtQsiPSgMeta } from "/workspace/app/pages/nosotros/terminos-y-condiciones.vue?macro=true";
import { default as politicas_45de_45devolucionIUX5X5FcnZENgwpUnCCFG8B4mPkruRBQkbnAG4VkCYgMeta } from "/workspace/app/pages/nosotros/politicas-de-devolucion.vue?macro=true";
import { default as garantias_45y_45devolucionesK7gazEld_kN5RjJU6ERiUytz15M2Ljvj8uXs877a0s8Meta } from "/workspace/app/pages/nosotros/garantias-y-devoluciones.vue?macro=true";
import { default as nosotroscS2cWCWWzdbUpDTpgoN87qAw7ZpllQAfQGKiT05uOfUMeta } from "/workspace/app/pages/nosotros.vue?macro=true";
import { default as mi_45cuentaFuyNBD69Pn_SPQ9JdUMirw_IiISUI77y5hnl3Ui3em0Meta } from "/workspace/app/pages/mi-cuenta.vue?macro=true";
import { default as eres_45robotragqVZ_rNRfAmdlmLcbJvrDZ9I9MOKtjTOlSbjW7N7QMeta } from "/workspace/app/pages/eres-robot.vue?macro=true";
import { default as registrarme_6k1mT9APNMVj7Jg2WYWn2WktwmPT7txfYlI_txAXWMMeta } from "/workspace/app/pages/registrarme.vue?macro=true";
import { default as _91id_93TbTq8YtLzSF9Y8JBSbYj8_wn6D0KtkY3m4he9aIBiBgMeta } from "/workspace/app/pages/landing/[id].vue?macro=true";
import { default as _91_91id_93_933rCZtw_CJyMJ1yV5jjZtXc_BBGyqAgWCWQyZeVQH1c8Meta } from "/workspace/app/pages/arma-tu-equipo/[[id]].vue?macro=true";
import { default as _91_91id_93_93qCBB7DGGVQwC7LEGKrVJFJH4BEzZwegeu8VT2j4FVaAMeta } from "/workspace/app/pages/arma-tu-equipo/[assemblyId]/[qty]/[[id]].vue?macro=true";
import { default as arma_45tu_45equipozqSBz2J1ZKbdOaEduZ8qF4dz2vxGkFClCU0Gazg80acMeta } from "/workspace/app/pages/arma-tu-equipo.vue?macro=true";
import { default as resetdEGTleht1_PaafDKeXSwZPG38_MV4K8WHbPNKEN_b38Meta } from "/workspace/app/pages/password/reset.vue?macro=true";
import { default as _91slug_93_J_UZhkJu3P0P3DCY_iWz_LMqb2JR_K2AXkQbn94BxQMeta } from "/workspace/app/pages/productos/[slug].vue?macro=true";
import { default as verificando_45humanotfxIGy0k81n9xWF3m5pLfVI6ROKiC64V7WETkTihQMAMeta } from "/workspace/app/pages/verificando-humano.vue?macro=true";
import { default as _91_46_46_46filters_93Y8deY_QuXLiABwhy4d1NfhRk_NBg6qig4uNvTZq1u3wMeta } from "/workspace/app/pages/buscar/[...filters].vue?macro=true";
import { default as _91id_93KA6PkeO91C3UdvcqSkLuzeFaazWVNJynvIwNVZcpsT8Meta } from "/workspace/app/pages/correo/verificar/[id].vue?macro=true";
import { default as busqueda_45por_45categoriaEtRDSbx_5WnBkmt0g_gwZ9CNirjuqUba5xtt3nq3LEgMeta } from "/workspace/app/pages/busqueda-por-categoria.vue?macro=true";
import { default as indexG7HkCKo8_Eg1OfMEGnin5g_oHyPvOyYxV0doD8q73r4Meta } from "/workspace/app/pages/correo/verificar/index.vue?macro=true";
import { default as verificacion_45dos_45pasosd1ugeshn9EBmgYR3hwra4BS63VK_vITpirVKcrZVeLgMeta } from "/workspace/app/pages/verificacion-dos-pasos.vue?macro=true";
import { default as reestablecerZsLcap_EUIMA6_JZ4_SCfFvCxREjqU6szTTjTvupe4UMeta } from "/workspace/app/pages/contrasena/reestablecer.vue?macro=true";
import { default as _91slug_93d0Xk_IkR56iKV5pLouXO_S_n0AwD67QwWm74Q1PbPuQMeta } from "/workspace/app/pages/productos/[partNumber]/[slug].vue?macro=true";
import { default as _91response_93_WMTkzr6_wGfkRFsKhTl6SU0aKmeQAX9auCM7Y6NAfgMeta } from "/workspace/app/pages/validate-address/[transactionId]/[code]/[missingPayment]/[response].vue?macro=true";
export default [
  {
    name: "home",
    path: "/",
    component: () => import("/workspace/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(loginnH9Sl924SFFqGThbV00_J_yNmCDLuvcG8JcX3TTI_1IMeta || {}), ...{"middleware":"previous-route"} },
    component: () => import("/workspace/app/pages/login.vue")
  },
  {
    name: "pagos",
    path: "/pagos",
    component: () => import("/workspace/app/pages/pagos.vue"),
    children: [
  {
    name: "success-payment",
    path: ":transactionId()/pago-exitoso",
    component: () => import("/workspace/app/pages/pagos/[transactionId]/pago-exitoso.vue")
  },
  {
    name: "process-payment",
    path: ":transactionId()/procesar-pago",
    component: () => import("/workspace/app/pages/pagos/[transactionId]/procesar-pago.vue")
  },
  {
    name: "pending-payment",
    path: ":transactionId()/pago-pendiente",
    component: () => import("/workspace/app/pages/pagos/[transactionId]/pago-pendiente.vue")
  },
  {
    name: "pagos-transactionPaymentId-pago-paypal",
    path: ":transactionPaymentId()/pago-paypal",
    component: () => import("/workspace/app/pages/pagos/[transactionPaymentId]/pago-paypal.vue")
  },
  {
    name: "pagos-transactionPaymentId-pago-oxxo-pay",
    path: ":transactionPaymentId()/pago-oxxo-pay",
    component: () => import("/workspace/app/pages/pagos/[transactionPaymentId]/pago-oxxo-pay.vue")
  },
  {
    name: "pagos-transactionPaymentId-pago-apple-pay",
    path: ":transactionPaymentId()/pago-apple-pay",
    component: () => import("/workspace/app/pages/pagos/[transactionPaymentId]/pago-apple-pay.vue")
  },
  {
    name: "pagos-transactionPaymentId-pago-google-pay",
    path: ":transactionPaymentId()/pago-google-pay",
    component: () => import("/workspace/app/pages/pagos/[transactionPaymentId]/pago-google-pay.vue")
  },
  {
    name: "pagos-transactionPaymentId-pago-mercadopago-pay",
    path: ":transactionPaymentId()/pago-mercadopago-pay",
    component: () => import("/workspace/app/pages/pagos/[transactionPaymentId]/pago-mercadopago-pay.vue")
  }
]
  },
  {
    name: "compra",
    path: "/compra",
    meta: {"middleware":["checkout-step"]},
    component: () => import("/workspace/app/pages/compra.vue"),
    children: [
  {
    name: "cart-review",
    path: ":transactionId?/revisar",
    component: () => import("/workspace/app/pages/compra/[[transactionId]]/revisar.vue")
  },
  {
    name: "cart-payment",
    path: ":transactionId?/elegir-pago",
    component: () => import("/workspace/app/pages/compra/[[transactionId]]/elegir-pago.vue")
  },
  {
    name: "cart-shipping",
    path: ":transactionId?/elegir-envio",
    component: () => import("/workspace/app/pages/compra/[[transactionId]]/elegir-envio.vue")
  },
  {
    name: "cart-detail",
    path: ":transactionId?/carrito/detalle",
    component: () => import("/workspace/app/pages/compra/[[transactionId]]/carrito/detalle.vue")
  },
  {
    name: "cart-monthly",
    path: ":transactionId?/elegir-mensualidad",
    component: () => import("/workspace/app/pages/compra/[[transactionId]]/elegir-mensualidad.vue")
  }
]
  },
  {
    name: "marcas",
    path: "/marcas",
    component: () => import("/workspace/app/pages/marcas.vue")
  },
  {
    name: "perfil",
    path: "/perfil",
    meta: perfil8Sy_UKg_9vVNZ0tdGxONizNO7SW_VX7oekU5WW_urJoMeta || {},
    component: () => import("/workspace/app/pages/perfil.vue"),
    children: [
  {
    name: "perfil-monedero",
    path: "monedero",
    component: () => import("/workspace/app/pages/perfil/monedero.vue")
  },
  {
    name: "profile.wishlist",
    path: "favoritos",
    component: () => import("/workspace/app/pages/perfil/favoritos.vue")
  },
  {
    name: "account-info",
    path: "informacion",
    component: () => import("/workspace/app/pages/perfil/informacion.vue")
  },
  {
    name: "perfil-dispositivos",
    path: "dispositivos",
    component: () => import("/workspace/app/pages/perfil/dispositivos.vue")
  },
  {
    name: "orders",
    path: "pedidos",
    component: () => import("/workspace/app/pages/perfil/pedidos/index.vue")
  },
  {
    name: "perfil-garantias-id",
    path: "garantias/:id?",
    component: () => import("/workspace/app/pages/perfil/garantias/[[id]].vue")
  },
  {
    name: "profile.addresses.create",
    path: "direcciones/crear",
    component: () => import("/workspace/app/pages/perfil/direcciones/crear.vue")
  },
  {
    name: "profile.addresses",
    path: "direcciones",
    component: () => import("/workspace/app/pages/perfil/direcciones/index.vue")
  },
  {
    name: "order-chat",
    path: "pedidos/:id()/chat",
    component: () => import("/workspace/app/pages/perfil/pedidos/[id]/chat.vue")
  },
  {
    name: "order-show",
    path: "pedidos/:id()",
    component: () => import("/workspace/app/pages/perfil/pedidos/[id]/index.vue")
  },
  {
    name: "order-confirmations",
    path: "confirmaciones",
    component: () => import("/workspace/app/pages/perfil/confirmaciones/index.vue")
  },
  {
    name: "perfil-metodos-pago-tarjeta",
    path: "metodos-pago/tarjeta",
    component: () => import("/workspace/app/pages/perfil/metodos-pago/tarjeta.vue")
  },
  {
    name: "profile.addresses.edit",
    path: "direcciones/:id()/editar",
    component: () => import("/workspace/app/pages/perfil/direcciones/[id]/editar.vue")
  },
  {
    name: "order-confirmation",
    path: "pedidos/:id()/confirmacion",
    component: () => import("/workspace/app/pages/perfil/pedidos/[id]/confirmacion.vue")
  },
  {
    name: "perfil-pedidos-id-garantia",
    path: "pedidos/:id()/garantia",
    component: () => import("/workspace/app/pages/perfil/pedidos/[id]/garantia/index.vue")
  },
  {
    name: "perfil-pedidos-id-garantia-productos",
    path: "pedidos/:id()/garantia/productos",
    component: () => import("/workspace/app/pages/perfil/pedidos/[id]/garantia/productos.vue")
  }
]
  },
  {
    name: "soporte",
    path: "/soporte",
    component: () => import("/workspace/app/pages/soporte.vue"),
    children: [
  {
    name: "support.stores",
    path: "sucursales",
    alias: ["/sucursales"],
    component: () => import("/workspace/app/pages/soporte/sucursales.vue")
  },
  {
    name: "soporte-contactanos",
    path: "contactanos",
    alias: ["/contactanos"],
    component: () => import("/workspace/app/pages/soporte/contactanos.vue")
  },
  {
    name: "support.faq",
    path: "facturacion",
    alias: ["/facturacion"],
    component: () => import("/workspace/app/pages/soporte/facturacion.vue")
  },
  {
    name: "support.payment_ways",
    path: "formas-de-pago",
    alias: ["/formas-de-pago"],
    component: () => import("/workspace/app/pages/soporte/formas-de-pago.vue")
  },
  {
    name: "soporte-preguntas-frecuentes",
    path: "preguntas-frecuentes",
    alias: ["/preguntas-frecuentes"],
    component: () => import("/workspace/app/pages/soporte/preguntas-frecuentes.vue")
  }
]
  },
  {
    name: "nosotros",
    path: "/nosotros",
    component: () => import("/workspace/app/pages/nosotros.vue"),
    children: [
  {
    name: "nosotros-privacidad",
    path: "privacidad",
    alias: ["/privacidad"],
    component: () => import("/workspace/app/pages/nosotros/privacidad.vue")
  },
  {
    name: "nosotros-aviso-legal",
    path: "aviso-legal",
    alias: ["/aviso-legal"],
    component: () => import("/workspace/app/pages/nosotros/aviso-legal.vue")
  },
  {
    name: "nosotros-terminos-y-condiciones",
    path: "terminos-y-condiciones",
    alias: ["/terminos-y-condiciones"],
    component: () => import("/workspace/app/pages/nosotros/terminos-y-condiciones.vue")
  },
  {
    name: "nosotros-politicas-de-devolucion",
    path: "politicas-de-devolucion",
    alias: ["/politicas-de-devolucion"],
    component: () => import("/workspace/app/pages/nosotros/politicas-de-devolucion.vue")
  },
  {
    name: "nosotros-garantias-y-devoluciones",
    path: "garantias-y-devoluciones",
    alias: ["/garantias-y-devoluciones"],
    component: () => import("/workspace/app/pages/nosotros/garantias-y-devoluciones.vue")
  }
]
  },
  {
    name: "mi-cuenta",
    path: "/mi-cuenta",
    component: () => import("/workspace/app/pages/mi-cuenta.vue")
  },
  {
    name: "failed-human-verify",
    path: "/eres-robot",
    component: () => import("/workspace/app/pages/eres-robot.vue")
  },
  {
    name: "registrarme",
    path: "/registrarme",
    component: () => import("/workspace/app/pages/registrarme.vue")
  },
  {
    name: "landing-id",
    path: "/landing/:id()",
    component: () => import("/workspace/app/pages/landing/[id].vue")
  },
  {
    name: "assembly-new",
    path: "/arma-tu-equipo",
    meta: { ...(arma_45tu_45equipozqSBz2J1ZKbdOaEduZ8qF4dz2vxGkFClCU0Gazg80acMeta || {}), ...{"middleware":"re-captcha"} },
    component: () => import("/workspace/app/pages/arma-tu-equipo.vue"),
    children: [
  {
    name: "assembly-edit",
    path: ":id?",
    component: () => import("/workspace/app/pages/arma-tu-equipo/[[id]].vue")
  },
  {
    name: "assembly-edit-with-cart",
    path: ":assemblyId()/:qty()/:id?",
    meta: {"middleware":["assembly-edit-with-cart"]},
    component: () => import("/workspace/app/pages/arma-tu-equipo/[assemblyId]/[qty]/[[id]].vue")
  }
]
  },
  {
    name: "password-reset",
    path: "/password/reset",
    component: () => import("/workspace/app/pages/password/reset.vue")
  },
  {
    name: "products_legacy",
    path: "/productos/:slug()",
    component: () => import("/workspace/app/pages/productos/[slug].vue")
  },
  {
    name: "human-verify",
    path: "/verificando-humano",
    component: () => import("/workspace/app/pages/verificando-humano.vue")
  },
  {
    name: "search",
    path: "/buscar/:filters(.*)*",
    component: () => import("/workspace/app/pages/buscar/[...filters].vue")
  },
  {
    name: "correo-verificar-id",
    path: "/correo/verificar/:id()",
    component: () => import("/workspace/app/pages/correo/verificar/[id].vue")
  },
  {
    name: "search_categories",
    path: "/busqueda-por-categoria",
    component: () => import("/workspace/app/pages/busqueda-por-categoria.vue")
  },
  {
    name: "correo-verificar",
    path: "/correo/verificar",
    component: () => import("/workspace/app/pages/correo/verificar/index.vue")
  },
  {
    name: "verificacion-dos-pasos",
    path: "/verificacion-dos-pasos",
    meta: verificacion_45dos_45pasosd1ugeshn9EBmgYR3hwra4BS63VK_vITpirVKcrZVeLgMeta || {},
    alias: ["/verificacion-dos-pasos"],
    component: () => import("/workspace/app/pages/verificacion-dos-pasos.vue")
  },
  {
    name: "contrasena-reestablecer",
    path: "/contrasena/reestablecer",
    component: () => import("/workspace/app/pages/contrasena/reestablecer.vue")
  },
  {
    name: "products",
    path: "/productos/:partNumber()/:slug()",
    component: () => import("/workspace/app/pages/productos/[partNumber]/[slug].vue")
  },
  {
    name: "validate-address-transactionId-code-missingPayment-response",
    path: "/validate-address/:transactionId()/:code()/:missingPayment()/:response()",
    component: () => import("/workspace/app/pages/validate-address/[transactionId]/[code]/[missingPayment]/[response].vue")
  }
]